import { Component } from '@angular/core';
import { GetAllStatusesData, getReviewsForLocation, GetReviewsForLocationData } from '@dataconnect/account'
import { Store } from '@ngrx/store';
import { QueryResult } from 'firebase/data-connect';
import { debounceTime, filter, lastValueFrom, take, takeUntil, tap } from 'rxjs';
import { authUserFeature } from '../../store/authUser.store';
import { Logger } from '../../helper/logger';
import { accountFeature } from '../../store/account.store';
import { listingsFeature } from '../../store/listings.store';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { ListingService } from '../../services/listing.service';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { ListingsCardComponent } from '../../component/layout/element/listing-card.component';
import { WrapperPageComponent } from "../../component/wrapper/page-wrapper.component";
import { SearchSideBarComponent } from "./search-side-bar.component";
import { LocationPublic } from '../../../../globalTypes/account.types';
import { FormsModule } from '@angular/forms';
import { SideDrawerComponent } from "../../component/layout/element/side-drawer.component";
import { CartComponent } from "../order/cart.component";
import { AuthUser } from '../../../../globalTypes/auth.types';
import { searchActions, searchFeature } from '../../store/search.store';
import { ButtonComponent } from "../../component/layout/element/button.component";
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { sleep } from '../../../../globalTypes/_helpers';
import { AUTHORIZED_ACCOUNT_LABEL } from '../../../../globalTypes/account.types';
import { NameTagComponent } from "../../component/layout/element/name.tag.component";
import { LocationReview, Review } from '../../../../globalTypes/review.types';
import { DecimalPipe } from '@angular/common';
import { RatingComponent } from '../../component/review/rating.component';
import { ReviewTileComponent } from "../../component/review/review.tile";
import { EditProductReviewDialogComponent } from '../../component/review/edit.review.dialog';
import { ViewProductReviewDialogComponent } from '../../component/review/view.review.dialog';
import { MatDialog } from '@angular/material/dialog';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { onCallFunctions } from '../../../../globalTypes/backend.api.types';
import { uiErrorCatcher } from '../../helper/error.handling';
import { Functions } from '@angular/fire/functions';
import { MatSnackBar } from '@angular/material/snack-bar';
const log = new Logger('ProfileListingsComponent');

@Component({
  selector: 'msh-profile-listings',
  imports: [ListingsCardComponent, RatingComponent, DecimalPipe, WrapperPageComponent, FormsModule, SearchSideBarComponent, SideDrawerComponent, CartComponent, ButtonComponent, NameTagComponent, ReviewTileComponent],
  template: `

  <msh-page-wrapper>
    @if(location){
      <msh-side-drawer [isHidden]="false">
        <div class="m-8">
          <msh-cart [standAlone]="true"></msh-cart>
        </div>
      </msh-side-drawer >
    }
    <div left-side-bar class=" fixed md:relative border-b md:border-none md:mt-4 w-full z-10 max-h-[90vh] ">
      <msh-search-side-bar></msh-search-side-bar>
    </div>
    <div class="flex gap-2 justify-between">
      <div>
        @if(locations[locationIdFromUrl || location?.id]; as profileLocation){
          <!-- location profile image -->
          <msh-name-tag 
            [isVerified]="profileLocation.verified"
            [owner]="profileLocation.owner.displayName"
            [label]="profileLocation.name"
            [url]="profileLocation.profileImage?.url"
            [size]="'small'"
          ></msh-name-tag>
          <div class="text-sm text-copy/50 mt-2 mb-4 ml-10">
            {{ profileLocation.description }}
          </div>
        }
      </div>
      <div  class="flex justify-center gap-4 flex-wrap mt-4">
        @if(reviews.reviewFor.length > 0){
          <div (click)="showAllReviews('reviewFor')" class="flex flex-col gap-2 text-sm justify-center items-center bg-copy/15 border border-copy/30 p-2 rounded">
            <div class="font-bold text-orange-500 uppercase">Reviews for:</div>
            <div class="flex gap-2 text-sm">
              <div>{{reviews.reviewForCount[0].total}} total</div>
              <div> | </div>
              <div>Avg. {{reviews.reviewForCount[0].ratingAvg | number:'1.1-2'}}</div>
            </div>
            <msh-rating [small]="true" [rating]="reviews.reviewForCount[0].ratingAvg || 3" [readonly]="true"></msh-rating>
            @if(reviews.reviewFor.length > 0){
              @if(displayReviewsType === 'reviewFor'){
                <div class="relative -top-2">showing</div>
              } @else {
                <div class="lil-action relative -top-2">show all</div>
              }
            }
          </div>
        }
        @if(reviews.reviewBy.length > 0){
          <div (click)="showAllReviews('reviewBy')" class="flex flex-col justify-center items-center gap-2 text-sm bg-copy/15 border border-copy/30 p-2 rounded">
            <div class="font-bold text-orange-500 uppercase">Reviews by:</div>
            <div class="flex gap-2 text-sm">
              <div>{{reviews.reviewByCount[0].total}} total</div>
              <div> | </div>
              <div>Avg. {{reviews.reviewByCount[0].ratingAvg | number:'1.1-2'}}</div>
            </div>
            <msh-rating [small]="true" [rating]="reviews.reviewByCount[0].ratingAvg || 3" [readonly]="true"></msh-rating>
            @if(reviews.reviewBy.length > 0){
              @if(displayReviewsType === 'reviewBy'){
                <div class=" relative -top-2">showing</div>
              } @else {
                <div class="lil-action relative -top-2">show all</div>
              }
            }
          </div>
        }
      </div>
    </div>
    @if(location){
      <div class="mb-4">

        <span class="uppercase text-sm opacity-50">Reviews {{displayReviewsType === 'reviewFor' ? 'for' : 'by'}} this location:</span>
        @if(reviews[displayReviewsType].length > 0){
          <div class="flex gap-4 flex-wrap my-2">
            @for(review of reviews[displayReviewsType]; track review.id){
              <msh-review-tile
                [small]="true"
                [review]="review"
                (click)="openReviewDialog(review)"
              ></msh-review-tile>
            }
          </div>
        } @else {
          <div class="null mt-4">No reviews {{displayReviewsType === 'reviewFor' ? 'for' : 'by'}} this location</div>
        }
      </div>
    }
      @if(listings.length){
        <div [class]="(listingsLoading ? ' animate-custom-pulse-opacity ' : '')+' grid mt-16 md:mt-4 gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'">
            @for(listing of listings; track listing.id){
              <msh-listings-card
                [userId]="authUser && authUser.id ? authUser.id : undefined"
                [listing]="listing"
                [locationId]="location?.id"
                [locations]="locations"
                [verifiedLocationNoun]="verifiedLocationNoun"
                class="flex justify-center"
              ></msh-listings-card>
            }
        </div>
      } @else if(isLoading){
        <div class="null mt-16 text-center">Loading results from this location<span class=" animate-bounce">.</span></div>
      } @else {
        <div class="null mt-16 text-center">No results from this location</div>
      }
    <div class=" flex justify-center my-8" >
      @if(couldBeMore){
        <msh-button [stealthMode]="true" cta="load more" (onClick)="loadMore()" > </msh-button>
      }
    </div>
  </msh-page-wrapper>

  `,
  styles: ``
})
export class ProfileListingsComponent extends Base<ProfileListingsComponent> {
  authUser!: AuthUser;
  statuses!: QueryResult<GetAllStatusesData, undefined>; // = getAllStatuses();
  listings: ListingPublic[] = [];
  location: any
  locations: {[locationId: string]: LocationPublic} = {};
  reviews: GetReviewsForLocationData = { reviewBy: [], reviewFor: [], reviewByCount: [{ total: 0, ratingAvg: 0 }], reviewForCount: [{ total: 0, ratingAvg: 0 }] };
  displayReviewsType: 'reviewBy' | 'reviewFor' = 'reviewFor';
  useParamsString = '';  
  couldBeMore = false;
  listingsLoading = false;
  isLoading = true;
  locationIdFromUrl: string | null = null;
  verifiedLocationNoun?: string;
  AUTHORIZED_ACCOUNT_LABEL = AUTHORIZED_ACCOUNT_LABEL

constructor(
  private store: Store,
  private listingsService: ListingService,
  private router: Router,
  private route: ActivatedRoute,
  private dialog: MatDialog,
  private functions: Functions,
  private snackBar: MatSnackBar,
  ) {
    super();

    this.router.events.pipe(takeUntil(this.$destroy)).subscribe((event) => {
      if (event instanceof NavigationEnd) {  
        if(this.route.snapshot.params['locationId']) {
          this.locationIdFromUrl = this.route.snapshot.params['locationId']
        } else {
          this.store.select(accountFeature.selectLocation).pipe(filter(l=>!!l), take(1)).subscribe(async (location) =>{
            if(!location) throw new Error("No location");
            this.location = location;
          })
        } 
      }
    })
    this.store.select(accountFeature.selectLocation).pipe(takeUntil(this.$destroy)).subscribe(async loc=>{
      this.location = loc; // JSON.parse(JSON.stringify(loc));
      if(!loc || !loc.id) return;
      const reviewsRef = await getReviewsForLocation({locationId:loc.id});
      this.reviews = reviewsRef.data;
      console.log({reviews: this.reviews})
    });
    this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy)).subscribe(locations=>{
      this.locations = locations
    });

    this.store.select(accountFeature.selectSegment).pipe(takeUntil(this.$destroy)).subscribe(segment=>{
      const noun = segment?.verifiedLocationNoun + '';
      const capitalizedNoun = noun?.charAt(0).toUpperCase() + noun?.slice(1);
      this.verifiedLocationNoun = capitalizedNoun;
    });
    // get reviews from and for this user

  }
  async ngOnInit() {
    // get url parameter for locationId and set store toggleOnlyListingsFromLocationId to that value, or find current locationId and set store toggleOnlyListingsFromLocationId to that value
    if(this.locationIdFromUrl){
      this.store.dispatch(searchActions.toggleOnlyListingsFromLocationId(this.locationIdFromUrl));
    } else {
      if(!this.location || !this.location.id) {
        this.location = await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(filter(l=>!!l), take(1)))
      }
      this.store.dispatch(searchActions.toggleOnlyListingsFromLocationId(this.location.id));
    }
    await sleep(1000); // wait for store to update before loading listings
    this.store.select(searchFeature.selectParams).pipe(
      filter(params=>!!params && Object.values(params).sort((a,b)=>a<b?1:-1).join(",") !== this.useParamsString),
      tap(params=>{this.useParamsString = Object.values(params).sort((a,b)=>a<b?1:-1).join(",")}),
      takeUntil(this.$destroy),
      debounceTime(500),
    ).subscribe(async params=>{
      log.log({onSelectParamsChange: this.useParamsString, params})
      this.couldBeMore = await this.listingsService.loadFilteredListings()
    })
    this.store.select(listingsFeature.selectListingsState).pipe(takeUntil(this.$destroy)).subscribe(state => {
      log.log({onListingStateChange: state})
      this.isLoading = state.isLoading;
      const listings = state.ids.filter(id=>!!state.entities[id]).map(id => state.entities[id]);
      this.listings = listings as ListingPublic[];
      log.log({listings})
      this.listingsLoading = state.isLoading;
    })
    this.authUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(filter(u=>!!u), take(1)))
    // // TODO: add user preferences to load the right results
   
  }


  async openReviewDialog(review?: Review | LocationReview){
    if(!review) return;
    const dialogComponent = review.reviewById === this.location.id ? EditProductReviewDialogComponent : ViewProductReviewDialogComponent;
    const dialog = this.dialog.open(dialogComponent, {data: {review}});
    const updatedReview = await lastValueFrom(dialog.afterClosed().pipe(take(1)));
    if(updatedReview){
      const callable = httpsCallable<{review: Review | LocationReview}, any>(this.functions,  onCallFunctions.submitReview);
      try {
        const results: HttpsCallableResult = await uiErrorCatcher(callable({review: updatedReview}), this.snackBar, "Error submitting review") 
        console.log({results})
        // change fulfillment status to something
        this.snackBar.open("Review submitted successfully", "close", {duration: 3000});
      } catch(error){
        log.error("Error submitting review", error)
      }
    }
  }

  showAllReviews(type: 'reviewBy' | 'reviewFor') {
    this.displayReviewsType = type;
  }

  async loadMore(){
    // add page
    this.store.dispatch(searchActions.increaseLoadAmount());
    this.couldBeMore = await this.listingsService.loadFilteredListings(true);
  }

}
